import { Fade } from 'react-awesome-reveal';
import { InternalBanner } from '../../components/internals/InternalBanner';
import './styles.scss';
export const NotFound = () => {
    return <Fade delay={1}>
        <main id="main" className='404-not-found'>
            <InternalBanner page={{post_title: 'Page Not Found'}}></InternalBanner>
            <section id="not-page-section">
                <div className='container'>
                    <article>
                        <h2>Oops! Page does not exist!</h2>
                    </article>
                </div>
            </section>
        </main>
    </Fade>
}